/* Look closer · The journal: the hover loupe for sections/look-closer-journal.liquid. Loaded with defer.
   On a fine pointer, a round lens follows the cursor over the painting and shows it at the section's zoom
   (--lcj-z). Touch screens and keyboard users get the image alone. */

if (!customElements.get('look-closer-journal')) {
  customElements.define('look-closer-journal', class extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('.lcj__frame--loupe');
      this.lens = this.querySelector('.lcj__lens');
      if (!this.frame || !this.lens || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      const z = parseFloat(getComputedStyle(this).getPropertyValue('--lcj-z')) || 2.5;
      this.onMove = (e) => {
        const r = this.frame.getBoundingClientRect();
        const x = e.clientX - r.left, y = e.clientY - r.top, h = this.lens.offsetWidth / 2;
        this.classList.add('is-loupe');
        this.lens.style.transform = 'translate(' + (x - h) + 'px,' + (y - h) + 'px)';
        this.lens.style.backgroundSize = (r.width * z) + 'px ' + (r.height * z) + 'px';
        this.lens.style.backgroundPosition = (-(x * z - h)) + 'px ' + (-(y * z - h)) + 'px';
      };
      this.onLeave = () => this.classList.remove('is-loupe');
      this.frame.addEventListener('pointermove', this.onMove);
      this.frame.addEventListener('pointerleave', this.onLeave);
    }
    disconnectedCallback() {
      if (!this.onMove) return;
      this.frame.removeEventListener('pointermove', this.onMove);
      this.frame.removeEventListener('pointerleave', this.onLeave);
    }
  });
}
